import { getConsumer } from "../../utils/common-utils";

export const preparePaystackProps = ({ purpose, amount }) => {
  const { email } = getConsumer();

  return {
    purpose,
    email,
    amount,
  };
};

export const getCurrencyGateways = (currency, gateways) => {
  const currencyGateway = gateways.find(
    ({ currencyCode }) => currencyCode === currency
  );

  return currencyGateway?.gateways || [];
};

export const getSupportedMethods = (gateways) => {
  const supportWallet = gateways.includes("WALLET");
  const supportCOD = gateways.includes("COD");
  const supportPaystack = gateways.includes("PAYSTACK");

  return { supportWallet, supportCOD, supportPaystack };
};

export const filterSavedCardsByCurrency = (cards, currency) => {
  return cards.filter(({currencyCode}) => currencyCode === currency);
}